import { Injectable } from '@angular/core';

@Injectable()
export class BiRelatorioAnaliseService {
  anoFiltro: any = '';
  mesInicial: any = '';
  mesFinal: any = '';
  dealer: any = '';
  mercado: any = '';
  regiao: any = '';
  grupoEconomico: any = '';

  constructor() { }

}
